import { api, apiV3 } from "@/api";
import {
  type IBillFileRequest,
  type IBillFileResponse,
  type IUploadBillFileConfirmRequest,
  type IUploadBillFileConfirmResponse,
  type IUploadBillFileRequest,
  type IUploadBillFileResponse,
} from "./types";

export const uploadBillFile = async (data: IUploadBillFileRequest) => {
  const response = await apiV3.post<IUploadBillFileResponse>(
    `/bill-files`,
    { fileContentBase64: data.fileContentBase64 },
    { headers: { jointBillServiceId: data.jointBillServiceId } },
  );

  return response.data;
};

export const uploadBillFileConfirm = async (
  data: IUploadBillFileConfirmRequest,
) => {
  const response = await api.post<IUploadBillFileConfirmResponse>(
    `/bill-files/confirmation`,
    {
      billFileId: data.billFileId,
      customerCode: data.customerCode,
      total: data.total,
      iban: data.iban,
    },
    { headers: { jointBillServiceId: data.jointBillServiceId } },
  );

  return response.data;
};

export const getBillFile = async (data: IBillFileRequest) =>
  (
    await api.get<IBillFileResponse>("/bill-files/", {
      params: { billId: data.billId },
      headers: { jointBillServiceId: data.jointBillServiceId },
    })
  ).data;
